import { IOverlayClusterParameter, IOverlayDelete, IResult } from "@/types/map";
import { loadModules } from "esri-loader";
import { Face3 } from "three";
//declare let FlareClusterLayer: any;
//import FlareClusterLayer from './Render/FlareClusterLayer_v4';
export class Cluster {
  private static intances: Map<string, any>;
  private view!: any;
  private clusterLayer: any;
  public showGisDeviceInfo: any;
  private maxSingleFlareCount = 15;
  private areaDisplayMode = "activated";
  private clusterGroups: Map<string, any> = new Map();

  private constructor(view: any) {
    this.view = view;
  }

  public static getInstance(view: any) {
    let id = view.container.id;
    if (!Cluster.intances) {
      Cluster.intances = new Map();
    }
    let intance = Cluster.intances.get(id);
    if (!intance) {
      intance = new Cluster(view);
      Cluster.intances.set(id, intance);
    }
    return intance;
  }

  public static destroy() {
    (Cluster.intances as any) = null;
  }

  public async deleteAllOverlaysCluster() {
    this.clearLayer(undefined);
  }

  public async deleteOverlaysCluster(params: IOverlayDelete) {
    // console.log("[debug][gisviewer-vue] deleteOverlaysCluster", params);
    let types = params.types;
    this.clearLayer(types);
  }

  public async getOverlaysCluster(type: string) {}

  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    const [Geometry, geometryEngine, geometryJsonUtils] = await loadModules(["esri/geometry/Geometry", "esri/geometry/geometryEngine", "esri/geometry/support/jsonUtils"]);

    let label = params.type;

    this.clearLayer([params.type] as string[]);

    let points = params.points || params.overlays || [];
    let clusterPic = params.ispic !== false;
    let popup = params.defaultTooltip;
    let zoom = params.zoom;
    let custom = params.custom;
    let textStyle = params.textStyle || {};
    let showRegion = params.showRegion === true;
    let defaultVisible = params.defaultVisible !== false;

    let clusterDisplay = params.clusterDisplay !== false;
    let drawRegion: Array<__esri.Geometry> | undefined = undefined;
    let scale = 0;
    let data: any = [];

    if (showRegion) {
      drawRegion = await this.getDrawOverlays();
    }
    console.log(this.view.map.allLayers, 2221);

    this.view.map.allLayers.getItemAt(0).tileInfo.lods.forEach((lod: any) => {
      if (lod.level == zoom) {
        scale = lod.scale;
      }
    });

    let defaultSym = this.makeSymbol(params.defaultSymbol);
    points.forEach((point: any, index: number) => {
      if (Number(point.geometry.x) > 0) {
        let obj: any = {
          x: Number(point.geometry.x),
          y: Number(point.geometry.y),
          id: point.id || index,
          type: params.type,
        };
        if (point.fields) {
          for (let field in point.fields) {
            obj[field] = point.fields[field];
          }
        }
        if (point.symbol) {
          obj.symbol = this.makeSymbol(point.symbol);
        } else {
          obj.symbol = defaultSym;
        }

        if (showRegion && drawRegion !== undefined) {
          let newArr = drawRegion.filter((geo: __esri.Geometry) => {
            return geometryEngine.contains(
              geo,
              geometryJsonUtils.fromJSON({
                x: obj.x,
                y: obj.y,
              })
            );
          });
          if (newArr.length > 0) {
            data.push(obj);
          }
        } else {
          data.push(obj);
        }
      }
    }, this);
    let width = 30;
    let height = 30;
    await this.initLayer({
      data: data,
      defaultSymbol: defaultSym,
      custom: custom,
      textStyle: {
        backgroundColor: textStyle.backgroundColor,
        borderLineColor: textStyle.borderColor,
        borderLineSize: textStyle.borderSize || 0,
        color: textStyle.color || "white",
        font: {
          size: textStyle.fontSize || 10,
          family: "Arial Unicode MS",
          style: "normal",
          weight: "normal", //默认字体
        },
        xoffset: textStyle.xoffset || 0,
        yoffset: textStyle.yoffset || 0,
      },
      clusterDisplay,
      defaultVisible,
      scale: scale,
      popup: popup,
      type: label,
      distance: params.distance,
      clusterPic: clusterPic,
      size: [defaultSym.width || width, defaultSym.height || height],
      subType: params.subType,
      topLeft: params.topLeft,
      bottomRight: params.bottomRight,
    });
    return {
      status: 0,
      message: "ok",
      result: data,
    };
  }

  public async getDrawOverlays(): Promise<Array<__esri.Geometry> | undefined> {
    let unionGeo: Array<__esri.Geometry> | undefined = undefined;
    const [geometryEngine, Graphic, WebMercatorUtils] = await loadModules(["esri/geometry/geometryEngine", "esri/Graphic", "esri/geometry/support/webMercatorUtils"]);
    let geometrys: any[] = [];
    let layer = this.view.map.allLayers.find((baselayer: any) => {
      return baselayer.type == "graphics" && baselayer.label === "drawOverlays";
    });
    console.log(layer, "数据显示");

    if (layer) {
      (layer as __esri.GraphicsLayer).graphics.forEach((graphic: __esri.Graphic) => {
        let geo = graphic.geometry.spatialReference.isWebMercator ? WebMercatorUtils.webMercatorToGeographic(graphic.geometry) : graphic.geometry;
        geometrys.push(geo);
      });
      unionGeo = geometrys;
      //unionGeo = await geometryEngine.union(geometrys);
    }

    return unionGeo;
  }

  private makeSymbol(sym: any): any {
    if (!sym) {
      return undefined;
    }
    let width = 30;
    let height = 30;
    let defaultSym = {};
    if (sym) {
      width = Number(sym.width || sym.size instanceof Array ? (sym.size as number[])[0] : sym.size);
      height = Number(sym.height || sym.size instanceof Array ? (sym.size as number[])[1] : sym.size);
      defaultSym = {
        type: "picture-marker",
        width: width || 30,
        height: height || 30,
        url: sym.url,
        xoffset: sym.xoffset || 0,
        yoffset: sym.yoffset || 0,
      };
    } else {
      defaultSym = {
        type: "simple-marker",
        size: 6,
        color: "#FF0000",
        outline: null,
      } as any;
    }
    return defaultSym;
  }

  //使toolTip中支持{字段}的形式
  private getToolTipContent(attrs: any, content: string): string {
    let tipContent = content;
    if (content) {
      //键值对
      for (let fieldName in attrs) {
        if (attrs.hasOwnProperty(fieldName)) {
          tipContent = tipContent.replace("{" + fieldName + "}", attrs[fieldName]);
        }
      }
    } else {
      tipContent = content;
    }
    return tipContent;
  }

  private async initLayer(params: any) {
    const [SpatialReference, PopupTemplate, ClassBreaksRenderer, PictureMarkerSymbol, SimpleFillSymbol, SimpleLineSymbol, SimpleMarkerSymbol, TextSymbol, libs, webMercatorUtils, Point, FeatureReductionCluster] = await loadModules([
      "esri/geometry/SpatialReference",
      "esri/PopupTemplate",
      "esri/renderers/ClassBreaksRenderer",
      "esri/symbols/PictureMarkerSymbol",
      "esri/symbols/SimpleFillSymbol",
      "esri/symbols/SimpleLineSymbol",
      "esri/symbols/SimpleMarkerSymbol",
      "esri/symbols/TextSymbol",
      "libs/FlareClusterLayer_v4.js",
      "esri/geometry/support/webMercatorUtils",
      "esri/geometry/Point",
      "esri/layers/support/FeatureReductionCluster",
    ]);
    //init the layer, more options are available and explained in the cluster layer constructor

    //set up a class breaks renderer to render different symbols based on the cluster count. Use the required clusterCount property to break on.
    let defaultSym = params.defaultSymbol; //params.defaultSymbol;
    defaultSym.type = "picture-marker";
    let size = params.size;
    let clusterPic = params.clusterPic;
    let custom = params.custom;
    let textStyle = params.textStyle;

    let renderer = new ClassBreaksRenderer({
      defaultSymbol: defaultSym,
    });
    console.log(renderer, "数据显示");

    renderer.field = "clusterCount";
    let smSymbol = new SimpleMarkerSymbol({
      size: 22,
      outline: new SimpleLineSymbol({ color: [221, 159, 34, 0.8] }),
      color: [255, 204, 102, 0.8],
    });
    let mdSymbol = new SimpleMarkerSymbol({
      size: 24,
      outline: new SimpleLineSymbol({ color: [82, 163, 204, 0.8] }),
      color: [102, 204, 255, 0.8],
    });
    let lgSymbol = new SimpleMarkerSymbol({
      size: 28,
      outline: new SimpleLineSymbol({ color: [41, 163, 41, 0.8] }),
      color: [51, 204, 51, 0.8],
    });
    let xlSymbol = new SimpleMarkerSymbol({
      size: 32,
      outline: new SimpleLineSymbol({ color: [200, 52, 59, 0.8] }),
      color: [250, 65, 74, 0.8],
    });
    if (clusterPic) {
      smSymbol = {
        type: "picture-marker",
        width: Number(size[0]) * 1.2,
        height: Number(size[1]) * 1.2,
        url: defaultSym.url,
        xoffset: defaultSym.xoffset,
        yoffset: defaultSym.yoffset * 1.2,
      };
      mdSymbol = {
        type: "picture-marker",
        width: Number(size[0]) * 1.5,
        height: Number(size[1]) * 1.5,
        url: defaultSym.url,
        xoffset: defaultSym.xoffset,
        yoffset: defaultSym.yoffset * 1.5,
      };
      lgSymbol = {
        type: "picture-marker",
        width: Number(size[0]) * 1.8,
        height: Number(size[1]) * 1.8,
        url: defaultSym.url,
        xoffset: defaultSym.xoffset,
        yoffset: defaultSym.yoffset * 1.8,
      };
      xlSymbol = {
        type: "picture-marker",
        width: Number(size[0]) * 2,
        height: Number(size[1]) * 2,
        url: defaultSym.url,
        xoffset: defaultSym.xoffset,
        yoffset: defaultSym.yoffset * 2,
      };
    }

    renderer.addClassBreakInfo(0, 1, defaultSym);
    renderer.addClassBreakInfo(1, 19, defaultSym);
    renderer.addClassBreakInfo(20, 150, defaultSym);
    renderer.addClassBreakInfo(151, 1000, defaultSym);
    renderer.addClassBreakInfo(1001, Infinity, defaultSym);

    let areaRenderer;

    // if area display mode is set. Create a renderer to display cluster areas. Use SimpleFillSymbols as the areas are polygons
    let defaultAreaSym = new SimpleFillSymbol({
      style: "solid",
      color: [0, 0, 0, 0.2],
      outline: new SimpleLineSymbol({ color: [0, 0, 0, 0.3] }),
    });

    areaRenderer = new ClassBreaksRenderer({
      defaultSymbol: defaultAreaSym,
    });
    areaRenderer.field = "clusterCount";

    let smAreaSymbol = new SimpleFillSymbol({
      color: [255, 204, 102, 0.4],
      outline: new SimpleLineSymbol({
        color: [221, 159, 34, 0.8],
        style: "dash",
      }),
    });
    let mdAreaSymbol = new SimpleFillSymbol({
      color: [102, 204, 255, 0.4],
      outline: new SimpleLineSymbol({
        color: [82, 163, 204, 0.8],
        style: "dash",
      }),
    });
    let lgAreaSymbol = new SimpleFillSymbol({
      color: [51, 204, 51, 0.4],
      outline: new SimpleLineSymbol({
        color: [41, 163, 41, 0.8],
        style: "dash",
      }),
    });
    let xlAreaSymbol = new SimpleFillSymbol({
      color: [250, 65, 74, 0.4],
      outline: new SimpleLineSymbol({
        color: [200, 52, 59, 0.8],
        style: "dash",
      }),
    });

    areaRenderer.addClassBreakInfo(0, 19, smAreaSymbol);
    areaRenderer.addClassBreakInfo(20, 150, mdAreaSymbol);
    areaRenderer.addClassBreakInfo(151, 1000, lgAreaSymbol);
    areaRenderer.addClassBreakInfo(1001, Infinity, xlAreaSymbol);

    // Set up another class breaks renderer to style the flares individually
    let flareRenderer = new ClassBreaksRenderer({
      defaultSymbol: renderer.defaultSymbol,
    });
    flareRenderer.field = "clusterCount";

    let smFlareSymbol = new SimpleMarkerSymbol({
      size: 14,
      color: [255, 204, 102, 0.8],
      outline: new SimpleLineSymbol({ color: [221, 159, 34, 0.8] }),
    });
    let mdFlareSymbol = new SimpleMarkerSymbol({
      size: 14,
      color: [102, 204, 255, 0.8],
      outline: new SimpleLineSymbol({ color: [82, 163, 204, 0.8] }),
    });
    let lgFlareSymbol = new SimpleMarkerSymbol({
      size: 14,
      color: [51, 204, 51, 0.8],
      outline: new SimpleLineSymbol({ color: [41, 163, 41, 0.8] }),
    });
    let xlFlareSymbol = new SimpleMarkerSymbol({
      size: 14,
      color: [250, 65, 74, 0.8],
      outline: new SimpleLineSymbol({ color: [200, 52, 59, 0.8] }),
    });

    flareRenderer.addClassBreakInfo(0, 1, defaultSym);
    flareRenderer.addClassBreakInfo(1, 19, smFlareSymbol);
    flareRenderer.addClassBreakInfo(20, 150, mdFlareSymbol);
    flareRenderer.addClassBreakInfo(151, 1000, lgFlareSymbol);
    flareRenderer.addClassBreakInfo(1001, Infinity, xlFlareSymbol);

    //set up a popup template
    let popupTemplate = undefined;
    if (params.popup) {
      popupTemplate = new PopupTemplate({
        title: "",
        content: params.popup,
      });
    }
    console.log(params);

    let options = {
      id: "flare-cluster-layer",
      clusterPic: true,
      custom: custom,
      clusterRenderer: renderer,
      areaRenderer: areaRenderer,
      flareRenderer: flareRenderer,
      singlePopupTemplate: popupTemplate,
      spatialReference: new SpatialReference({ wkid: 4326 }),
      subTypeFlareProperty: params.subType || "type", // the property name that the subtype flare will use to count on
      singleFlareTooltipProperty: params.subType || "type", // The property name of the dataset to display in a tooltip for a flare when a flare represents a single object.
      displaySubTypeFlares: true,
      maxSingleFlareCount: this.maxSingleFlareCount,
      clusterRatio: params.distance || 75,
      clusterAreaDisplay: this.areaDisplayMode,
      clusterDisplay: params.clusterDisplay,
      clusterToScale: params.scale,
      data: params.data,
      textSymbol: new TextSymbol(textStyle),
      animateFlares: false, // 禁用动画
      labelingInfo: null, // 禁用标签
      view: this.view, //map
      dataList: params.data.filter((item: any) => {
        let pointX = item.x; //121.XXX
        let pointY = item.y; //31.XXX
        let bianMinX = params.topLeft.longitude; //121.XX
        let bianMinY = params.topLeft.latitude; //121.XX

        let bianMaxX = params.bottomRight.longitude; //121.XX
        let bianMaxY = params.bottomRight.latitude; //121.XX
        return pointX > bianMinX && pointX < bianMaxX && pointY > bianMinY && pointY < bianMaxY;
      }), //保存可是区域内的数据
      // refreshOnStationary: false,
    };

    let clusterLayer = new libs.FlareClusterLayer(options);
    // let clusterLayer = new FeatureReductionCluster(options);
    clusterLayer.label = params.type;
    clusterLayer.visible = params.defaultVisible;

    await this.view.map.add(clusterLayer);
    this.clusterGroups.set(params.type, clusterLayer);
  }

  private clearLayer(types: string[] | undefined) {
    if (types && types.length > 0) {
      types.forEach(type => {
        let layer = this.clusterGroups.get(type);
        if (layer) {
          this.view.map.remove(layer);
          this.clusterGroups.delete(type);
        }
      }, this);
    } else {
      this.clusterGroups.forEach((layer: any) => {
        this.view.map.remove(layer);
      });
      this.clusterGroups.clear();
    }
  }
}
